import React, { useContext } from "react";
import Logo from "../images/newimg/footerlogo.svg";
import { Image } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitterSquare,
  FaTiktok,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { AuthContext } from "../../utility/services/AuthContext";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import GoogleImg from "../images/newimg/googleimg.png";
import AppleImg from "../images/newimg/appleimg.png";

const Footer = () => {
  //////////////////////////////////// LOGICAL VARIABLES ///////////////////////////////////////////////
  React.useEffect(() => {
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const { user, footer_ref } = useContext(AuthContext);

  const isUserDetails = user.details != null;
  const role = isUserDetails ? user.details.role : "";

  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();

  return (
    <section className="footer">
      <div ref={footer_ref} className="container-fluid customContainer">
        <div className="row">
          <div
            className="col-md-3"
            data-aos="fade-right"
            data-aos-duration="2000"
            data-aos-delay="250"
          >
            <Image src={Logo} className="flogo img-fluid" />
            <p>
              eCare Therapy provides a safe and non-judgmental space to explore
              our thoughts, feelings, and experiences.
            </p>
            <div className="social">
              <Link
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/profile.php?id=100092975601910&mibextid=LQQJ4d"
                  );
                }}
              >
                <FaFacebook />
              </Link>
              <Link
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/ecaretherapy?igsh=MWh2YnU5bW1nMWh0aQ%3D%3D&utm_source=qr"
                  );
                }}
              >
                <FaInstagram />
              </Link>
              <Link
                onClick={() => {
                  window.open("https://x.com/eCareTherapy");
                }}
              >
                <FaTwitterSquare />
              </Link>
              <Link
                onClick={() => {
                  window.open(
                    "https://www.tiktok.com/@ecaretherapy?_t=8oKmX1kOtX4&_r=1"
                  );
                }}
              >
                <FaTiktok size={20} />
              </Link>
            </div>
          </div>
          <div className="col-md-7 offset-lg-2 alignLeft">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div
                    className="col-md-4"
                    data-aos="fade-down"
                    data-aos-duration="2000"
                    data-aos-delay="250"
                  >
                    <h2>Navigate</h2>
                    <ul>
                      <li>
                        <Link
                          to={
                            isUserDetails
                              ? role == "Therapist"
                                ? "/dashboard"
                                : role == "Patient"
                                ? "/dashboard"
                                : "/"
                              : "/"
                          }
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/about"> About Us</Link>
                      </li>

                      {isUserDetails ? (
                        role == "Therapist" ? null : (
                          <li>
                            <Link to="/findtherapist">Find Therapists</Link>
                          </li>
                        )
                      ) : (
                        <li>
                          <Link to="/findtherapist">Find Therapists</Link>
                        </li>
                      )}

                      {(!isUserDetails || role == "Therapist") && (
                        <li>
                          <Link to="/therapist">For Therapists</Link>
                        </li>
                      )}

                      <li>
                        <Link to="/news"> News</Link>
                      </li>
                      <li>
                        <Link to="/contactus">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/q&a">Q&A</Link>
                      </li>
                    </ul>
                  </div>
                  <div
                    className="col-md-4 legal"
                    data-aos="fade-down"
                    data-aos-duration="2000"
                    data-aos-delay="250"
                  >
                    <h2>Legal</h2>
                    <ul>
                      <li>
                        <Link
                          onClick={() => {
                            window.open("/helpandsupport", "_blank");
                          }}
                        >
                          Help & Support
                        </Link>
                      </li>
                      <li>
                        <Link
                          onClick={() => {
                            window.open("/privacypolicy", "_blank");
                          }}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        {isUserDetails ? (
                          <Link
                            onClick={() => {
                              window.open("/termsofservice", "_blank");
                            }}
                          >
                            Terms of Service
                          </Link>
                        ) : (
                          <Link
                            onClick={() => {
                              window.open("/termsofservice", "_blank");
                            }}
                          >
                            Terms of Service
                          </Link>
                        )}
                      </li>
                      <li>
                        <Link
                          onClick={() => {
                            window.open("/hipaa", "_blank");
                          }}
                        >
                          HIPAA Compliance Agreement
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div
                    className="col-md-4"
                    data-aos="fade-left"
                    data-aos-duration="2000"
                    data-aos-delay="250"
                  >
                    <h2>Download the App</h2>
                    <ul>
                      <li>
                        <span>For individuals</span>
                        <div className="socialImg">
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.ecaretherapy.app"
                              );
                            }}
                          >
                            <img src={GoogleImg} className="img-fluid" alt="" />
                          </Link>

                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                "https://apps.apple.com/in/app/ecare-therapy/id6477286804"
                              );
                            }}
                          >
                            <img src={AppleImg} className="img-fluid" alt="" />
                          </Link>
                        </div>
                      </li>
                      <li>
                        <span>For therapists</span>
                        <div className="socialImg">
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.ecaretherapist.app"
                              );
                            }}
                          >
                            <img src={GoogleImg} className="img-fluid" alt="" />
                          </Link>

                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                "https://apps.apple.com/in/app/ecare-for-therapists/id6477288287"
                              );
                            }}
                          >
                            <img src={AppleImg} className="img-fluid" alt="" />
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="copyright">
              <p>eCare Therapy | {currentYear} | All Rights Reserved</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
